import * as React from 'react';
import { Overlay } from '../components/Overlay';

interface Props {
  action: string;
}

export const ProcessingModal: React.FunctionComponent<Props> = props => {
  return (
    <Overlay hideCloseButton={true}>
      <h1>
        {props.action}
        <span className="ellipsis-anim">
          <span>.</span>
          <span>.</span>
          <span>.</span>
        </span>
      </h1>
    </Overlay>
  );
};



// WEBPACK FOOTER //
// ./src/components/ProcessingModal.tsx